<template>
  <div>
    <div style="margin-bottom: 20px;">
      <Button
        :label="t('Nova Conta')"
        icon="pi pi-plus"
        severity="primary"
        size="small"
        data-testid="contas-novo-button"
        @click="openModal"
      />
    </div>

    <!-- Contas Table -->
    <contas-table
      ref="contasTableRef"
      @edit="handleEdit">
    </contas-table>

    <!-- ContasModal is centralized in ModalManager.vue - opened via eventBus -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';
import ContasTable from './ContasTable.vue';
// ContasModal is centralized in ModalManager.vue

type ContaId = number | string;

interface ContasTableInstance {
  loadData: () => Promise<void> | void;
}

withDefaults(defineProps<{
  usuarioVersao?: number;
  translations?: Record<string, unknown>;
  datatablesLanguageUrl?: string;
}>(), {
  usuarioVersao: 0,
  translations: () => ({}),
  datatablesLanguageUrl: ''
});

const { t } = useI18n();

const contasTableRef = ref<ContasTableInstance | null>(null);

const loadData = async (): Promise<void> => {
  log('ContasPage', 'loadData', 'Refreshing table');
  if (contasTableRef.value) {
    await contasTableRef.value.loadData();
  }
};

const openModal = (): void => {
  log('ContasPage', 'openModal', 'Opening new account modal via eventBus');
  eventBus.emit('modal.contas.open', { action: 'new' });
};

const handleEdit = (contaId: ContaId): void => {
  log('ContasPage', 'handleEdit', 'Editing account ID via eventBus', contaId);
  eventBus.emit('modal.contas.open', { id: contaId });
};

const handleEditEvent = (contaId?: ContaId): void => {
  log('ContasPage', 'handleEditEvent', 'Received contas.edit event', contaId);
  if (contaId !== undefined) handleEdit(contaId);
};

onMounted(() => {
  log('ContasPage', 'mounted', 'Component mounted');
  eventBus.on('contas.edit', handleEditEvent);
  eventBus.on('contas.new', openModal);
});

onBeforeUnmount(() => {
  log('ContasPage', 'beforeUnmount', 'Cleaning up event listeners');
  eventBus.off('contas.edit', handleEditEvent);
  eventBus.off('contas.new', openModal);
});

defineExpose({
  loadData,
  openModal,
  handleEdit
});
</script>
